import { useAxiosCreate } from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header'

const api = useAxiosCreate('base')

export async function listOrphans(model) {
	const res = await api.get('/api/v2/admin/orphans', {
		params: { model },
		headers: authHeader(),
	})
	return res.data
}

export async function deleteOrphan(model, id) {
	const res = await api.delete(`/api/v2/admin/orphans/${model}/${id}`, {
		headers: authHeader(),
	})
	return res.data
}
